/**
 * For services that are registered through an interface, a token is required.
 * @see {@link https://github.com/microsoft/tsyringe#example-with-interfaces }
 */
export enum ServiceTokens {
  GeoCoordinatesService = "GeoCoordinatesService",
  PageAttributesExtractor = "PageAttributesExtractor",
  SiteSettings = "SiteSettings",
  UserDataLayerAdapterFactory = "UserDataLayerAdapterFactory",
}
